import { FadeIn } from '../../components/AnimateIn'
import Button from '../../components/Button'
import Section from '../../components/Section'
import { Text } from '../../components/Text'

export default function Media() {
  return (
    <div className="bg-cover bg-left lg:bg-center justify-center bg-[url('assets/media.jpg')] min-h-[525px]">
      <Section withVerticalPadding>
        <div className='flex flex-col gap-[44px] max-w-[622px]'>
          <FadeIn>
            <Text.H2 className='text-inverse' underline={'white'}>
              Explore & Learn
            </Text.H2>
          </FadeIn>
          <FadeIn delay={0.2}>
            <Text.Body className='text-inverse'>
              Looking to explore our latest sermons, bible studies, music and media?
              <br />
              <br />
              Our platform has resources to inspire, edify and deepen your faith – sermons, study
              sessions, messages of various meetings, synopsis of various church events like
              Picnics, Love feast, Sunday School anniversary, Youth meetings and many such events.
            </Text.Body>
          </FadeIn>
          <FadeIn delay={0.3}>
            <div className='flex'>
              <Button
                variant='inverseDisabled'
                className='min-w-[126px]'
                icon='ArrowRight'
                iconPosition='right'
                disabled
              >
                Coming Soon
              </Button>
            </div>
          </FadeIn>
        </div>
      </Section>
    </div>
  )
}
